import PriceListTable from '../../../components/PriceListTable'

const PriceListTab = ({ period }) => {
  if (!period) return null
  return <PriceListTable period={period} />
}

export default PriceListTab
